export default {
    workOrder_location_edit_title: "Editar Ubicación",
    workOrder_location_create_title: "Crear Nueva Ubicación",
    workOrder_location_no_changes_to_save: "No hay cambios para guardar",
    workOrder_location_location_saved: "Ubicación Guardada",
    workOrder_location_nameIsAlreadyInUse: "El nombre ya está en uso",
    workOrder_location_name: "Nombre",
    workOrder_location_type: "Tipo",
    workOrder_location_address: "Dirección",
    workOrder_location_descripcion: "Descripción",
    workOrder_location_main: "Principal",
    workOrder_location_regular: "Regular",
    workOrder_location_billing: "Facturación",
    workOrder_location_addressFormatError: "La dirección no es válida"
};